import { render, staticRenderFns } from "./PassengerDetails.vue?vue&type=template&id=1610cf20&scoped=true&"
import script from "./PassengerDetails.vue?vue&type=script&lang=js&"
export * from "./PassengerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610cf20",
  null
  
)

export default component.exports